import { pxToEm } from 'util/pxToEm';
import { Box, Typography } from '@mui/material';
import React, { ReactElement } from 'react';

export interface NotificationHeaderProps {
  unreadCount: number;
  onMarkAllAsRead: () => void;
}

export const NotificationHeader = ({
  unreadCount,
  onMarkAllAsRead,
}: NotificationHeaderProps): ReactElement => {
  if (unreadCount === 0)
    return <></>;


  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      mb={16}
      px={16}
      sx={{ cursor: 'pointer' }}
      onClick={onMarkAllAsRead}
    >
      <Typography
        sx={{
          fontSize: pxToEm(14),
          color: theme => theme.palette.primary.main,
          textDecoration: 'underline',
        }}
      >
        Mark all as read
      </Typography>
    </Box>
  );
};

